import { ECustomFormatter } from "motw_core/Enums/ECustomFormatter";
import * as React from "react";

export function GetCustomFormattedText(
    textToDisplay: string,
    customFormatter: ECustomFormatter
) {
    if (customFormatter === ECustomFormatter.NoFrills) {
        var result = GetNoFrillsFormattedText(textToDisplay);
        return result;
    }

    return <span>Unknown formatter!</span>;
}

function GetNoFrillsFormattedText(textToDisplay: string) {
    if (textToDisplay.includes("!")) {
        return <span style={{ color: `coral` }}>{textToDisplay}</span>;
    }

    if (
        textToDisplay.toUpperCase().includes("IOS") ||
        textToDisplay.includes("?")
    ) {
        return <span style={{ fontStyle: "italic" }}>{textToDisplay}</span>;
    }

    return <span>{textToDisplay}</span>;
}
